import type { AccountInfo } from '@azure/msal-browser';
import { useAccount, useMsal } from '@azure/msal-react';
import { logger } from '@celito.clients/services';

export const SUPER_ADMIN_ROLE = 'SuperAdmin';

/**
 * Return only valid string-valued Entra application roles from an MSAL account.
 * Claims are external input, so keep malformed role values out of authorization
 * decisions instead of relying on a type assertion alone.
 */
export const getEntraRoles = (account: AccountInfo | null): string[] => {
  const roles = (account?.idTokenClaims as Record<string, unknown> | undefined)
    ?.roles;

  return Array.isArray(roles)
    ? roles.filter((role): role is string => typeof role === 'string')
    : [];
};

export const useEntraRoles = () => {
  const { accounts } = useMsal();
  const account = useAccount(accounts[0] ?? null);
  const roles = getEntraRoles(account);
  return {
    account,
    roles,
    isSuperAdmin: roles.includes(SUPER_ADMIN_ROLE),
  };
};
